export const SLRestEndpoint = "/sl3/rest";
export const SLEndpoint = "/sl3/";
